<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            已入住老人列表
        </div>
        <div style="padding: 20px;">

            <div>
                <el-row>
                    <!-- <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button> -->
                    <el-button type="success" :disabled="disabledEdit"  @click="handleEdit">编辑</el-button>
                    <el-button type="danger" :disabled="disabledExport" @click.native="toggleModalExport">档案导出</el-button>
                    <el-button type="warning" :disabled="disabledLeave" @click.native="toggleModalLeave">请假记录</el-button>
                    <!-- <el-button type="warning" @click.native="testLeave">记录导出</el-button> -->
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="name" clearable @change="getList" style="margin:0 10px;width:200px"></el-input>
                        <el-input  placeholder="请输入身份证号" v-model="idCard" clearable @change="getList" style="margin-right:10px;width:200px"></el-input>
                        <el-select v-model="checkinStatus" placeholder="入住状态">
                            <el-option
                            v-for="item in checkinStatusValue"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row :height="th" border style="width: 100%;" @row-click='rowClick'>
                        <el-table-column label="老人姓名" prop="name" width="100"></el-table-column>
                        <el-table-column label="手机号" prop="phone" width="120"></el-table-column>
                        <el-table-column label="身份证号" prop="idCard" width="180"></el-table-column>
                        <el-table-column label="年龄" prop="age" width="60"></el-table-column>
                        <el-table-column label="性别" prop="gender" width="60">
                            <template slot-scope="scope">
                                <span v-if="scope.row.gender==0">女</span>
                                <span v-if="scope.row.gender==1">男</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
                        <el-table-column prop="deposit"  width="100" label="预交金(元)"></el-table-column>
                        <el-table-column prop="imprest"  width="100" label="备用金(元)"></el-table-column>
                        <el-table-column prop="checkinStatus" label="入住状态" width="100">
                            <template slot-scope="scope">
                                <span style="color:red" v-if="scope.row.checkinStatus==0">已预约</span>
                                <span v-if="scope.row.checkinStatus==1">已入住</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="地址" prop="areaName" ></el-table-column>
                        <el-table-column label="详细住址" prop="address" ></el-table-column>
                        
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                
                                <el-button type="success" size="small" @click="handleInfo(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:areaValue="areaValue" v-bind:nationValue="nationValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:areaValue="areaValue" v-bind:nationValue="nationValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <Info ref="myInfo" v-show="showModalInfo" v-bind:areaValue="areaValue" v-bind:nationValue="nationValue" v-on:closeInfo="showModalInfo=false" v-on:getList="getList"></Info>
        <Export ref="myExport" v-show="showModalExport" v-on:closeExport="showModalExport=false" v-on:getList="getList"></Export>
        <Leave ref="myLeave" v-show="showModalLeave" v-on:closeLeave="showModalLeave=false" v-on:getList="getList"></Leave>
        <HistoricalFiles ref="myHistoricalFiles" v-show="showModalHistoricalFiles" v-on:closeHistoricalFiles="showModalHistoricalFiles=false"></HistoricalFiles>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import Info from "./Info";
    import Export from "./Export";
    import Leave from "./Leave";
    import HistoricalFiles from "./HistoricalFiles";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                disabledAdd:true,
                menuButtonList:null,
                showModalAdd:false,
                showModalEdit:false,
                showModalHistoricalFiles:false,
                showModalExport:false,
                showModalLeave:false,
                disabledExport:true,
                disabledLeave:true,
                disabledEdit:true,
                disabledDel:true,
                disabledHistory:true,
                showModalInfo:false,
                name:'',
                idCard:'',
                areaValue:[],
                nationValue:[],
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                checkinStatus:-1,
                checkinStatusValue:[{name:'全部入住状态',value:-1},{name:'已预约',value:0},{name:'已入住',value:1}],
                row:null

            }
        },
        components:{
            Add,Edit,Info,Export,Leave,HistoricalFiles
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                console.log(menu)
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        // if(menu[i].buttonName=="添加"){
                        //     this.disabledAdd = false;
                        // }
                    }
                }
                if(this.menuButtonList.indexOf("历史档案")!=-1){
                    this.disabledHistory =false;
                }
            },
            delElderly(){
                this.$confirm('确认删除 '+this.row.name +' , 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.delSubmit();
                        
                    
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },
            delSubmit(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/DelElderly",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyCode:this.row.elderlyCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$message("删除成功");
                            this.getList();
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            init(){
                this.areaValue = JSON.parse(window.localStorage.getItem('areaValue'));
                // this.$axios({
                //     method: 'post',
                //     url: this.$institutionUrl+"Area/ListAll",
                //     data: {
                //         timeStr: timeStr,
                //         sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                //         staffCode: getStaffCode(),
                //     }
                // }).then(
                //     (response) => {
                //         if (response.data.error == 0) {
                //             var data=JSON.stringify(response.data.data);
                //             data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                //             this.areaValue = data
                //         }else if(response.data.error == 1){
                //             this.$message({type: 'info', message: response.data.message});
                //         }
                //     }
                // )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"SysNation/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.nationValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
               
            },
            rowClick(val) {
                this.row = val;
                  this.disabledExport =false;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                // if(this.menuButtonList.indexOf("档案导出")!=-1){
                //     this.disabledExport =false;
                // }
                if(this.menuButtonList.indexOf("请假记录")!=-1){
                    this.disabledLeave =false;
                }
           
                
            },
            handleEdit() {
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            handleInfo(row) {
                this.$refs.myInfo.init(row);
                this.showModalInfo = !this.showModalInfo;
            },
            toggleHistory(){
                this.$refs.myHistoricalFiles.init();
                this.showModalHistoricalFiles = !this.showModalHistoricalFiles;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            closeLeave:function(){
                this.showModalLeave = !this.showModalLeave;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalExport:function(){
                this.showModalExport = !this.showModalExport;
                this.$refs.myExport.init(this.row);
            },
            toggleModalLeave:function(){
                this.showModalLeave = !this.showModalLeave;
                this.$refs.myLeave.init(this.row);
            },
            closeExport:function(){
                this.showModalExport = !this.showModalExport;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statusTitle(row){
                if(row.checkinStatus == 0){
                    return "已预约";
                }
                if(row.checkinStatus == 1){
                    return "已入住";
                }
                return "其它";
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/GetListByCheckinStatus",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        idCard:this.idCard,
                        checkinStatus:this.checkinStatus,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true;
                    this.disabledDel=true;
                    this.disabledExport=true;
                    this.disabledLeave = true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style lang="scss" scoped>

    /deep/ .el-table__body tr.current-row>td  {
        background-color: #409EFF;
        color:#fff;
    }
</style>
